import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { ZoomTable } from 'components/Tables/ZoomTable';
const Zoom: FC = observer(() => {
  return <ZoomTable />;
});

export default Zoom;
